import React, { Component } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import BuildingsApi from "../../api/BuildingsApi";
import AuthService from "../../session/AuthService";
import EnlargeImage from "../../customFunctions/EnlargeImage";
import { API_URL } from "../../config/app-config";

class CreateBuildings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formValues: {},
      isModalOpen: false,
    };
  }

  getBaseUrl = () => {
    const hostname = window.location.hostname;

    if (hostname === "localhost") {
      return "http://localhost:8081";
    } else if (hostname === "farmconnect.betalearnings.com") {
      return "http://farmconnect.betalearnings.com/FarmConnect";
    } else if (hostname === "35.182.98.99") {
      return "http://35.182.98.99/FarmConnect";
    } else {
      // Add a default case or return an error message if none of the conditions match
      return "http://defaultBaseUrl";
    }
  };

  componentDidMount = () => {
    console.log("this.props.editValue", this.props.editValue);
    if (
      this.props.editValue &&
      Object.keys(this.props.editValue).length > 0 &&
      this.props.option === "edit"
    ) {
      this.setState(
        {
          formValues: this.props.editValue,
          colorChange: true,
        },
        () => {}
      );
    }
  };

  render() {
    return (
      <>
        <Modal
          show={this.props.show}
          onHide={this.props.handleClose}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <h5 style={{ fontWeight: "bolder" }}>
              {this.props.option === "edit" ? "Edit Building" : "Add Building"}
            </h5>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-1" controlId="exampleForm.ControlInput1">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                // placeholder="Name"
                autoFocus
                name="building_name"
                className="small-input"
                value={this.state.formValues.building_name}
                onChange={this.handleChange}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              />
            </Form.Group>

            <div class="form-group" style={{ marginBottom: "10px" }}>
              <label
                for="exampleFormControlTextarea1"
                style={{ fontSize: "14px", fontWeight: 500 }}
              >
                Description
              </label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                name="building_desc"
                onChange={this.handleChange}
                value={this.state.formValues.building_desc}
                style={{ backgroundColor: "#F3F4F1", borderColor: "#F3F4F1" }}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              ></textarea>
            </div>

            <div className="Border-line"></div>

            <div className="row">
              <div className="col">
                <Form.Group
                  className="mb-1"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Year</Form.Label>
                  <Form.Control
                    type="number"
                    // placeholder="Year"
                    autoFocus
                    className="small-input"
                    name="year"
                    value={this.state.formValues.year}
                    onChange={this.handleChange}
                    maxLength={4}
                    onInput={(e) => {
                      // Allow only numbers
                      e.target.value = e.target.value
                        .replace(/[^0-9]/g, "")
                        .slice(0, 4);
                    }}
                    onPaste={(e) => {
                      // Handle paste events
                      const pastedText = e.clipboardData.getData("text/plain");
                      const pastedNumbers = pastedText
                        .replace(/[^0-9]/g, "")
                        .slice(0, 4);
                      e.preventDefault();
                      document.execCommand("insertText", false, pastedNumbers);
                    }}
                    readOnly={AuthService.getUserTypeAdmin() === "3"}
                  />
                </Form.Group>
              </div>
              <div className="col">
                <Form.Group
                  className="mb-1"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Year Acquired</Form.Label>
                  <Form.Control
                    type="text"
                    // placeholder="Year Acquired"
                    autoFocus
                    className="small-input"
                    name="year_acquired"
                    value={this.state.formValues.year_acquired}
                    onChange={this.handleChange}
                    readOnly={AuthService.getUserTypeAdmin() === "3"}
                  />
                </Form.Group>
              </div>
            </div>
            <div class="form-group" style={{ marginBottom: "10px" }}>
              <label
                for="exampleFormControlTextarea1"
                style={{ fontSize: "14px", fontWeight: 500 }}
              >
                Notes
              </label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                name="notes"
                onChange={this.handleChange}
                value={this.state.formValues.notes}
                style={{ backgroundColor: "#F3F4F1", borderColor: "#F3F4F1" }}
                readOnly={AuthService.getUserTypeAdmin() === "3"}
              ></textarea>
            </div>

            <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
              <Form.Label>Time Service Interval with Activity</Form.Label>
              <select
                className="form-select form-select-sm"
                aria-label=".form-select-sm example"
                id="form-select-sm-employee"
                name="service_interval"
                value={this.state.formValues.service_interval}
                onChange={this.handleChange}
                style={{ color: this.state.colorChange ? "black" : "#747c84" }}
                disabled={AuthService.getUserTypeAdmin() === "3"}
              >
                <option selected>Select</option>
                <option value="semi">Semi</option>
                <option value="quarterly">Quarterly</option>
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
              </select>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicNo">
              <Form.Label>Upload File</Form.Label>
              <br />
              <div className="custom-file">
                {this.state.formValues.resourceImage ? (
                  <label htmlFor="customFile" className="file-label">
                    {this.state.formValues.resourceImage.name}
                  </label>
                ) : (
                  <label htmlFor="customFile" className="file-label">
                    {this.props.option === "edit" &&
                    this.props.editValue.orginalImageName !== null
                      ? this.props.editValue.orginalImageName
                      : "Click to Upload File"}
                  </label>
                )}
                <input
                  type="file"
                  id="customFile"
                  onChange={this.handlefile}
                  name="resourceImage"
                  accept="image/*"
                  disabled={AuthService.getUserTypeAdmin() === "3"}
                />
              </div>
            </Form.Group>

            <div className="Image-perview-container">
              {this.props.option === "edit" &&
              this.state.formValues.buildingImage !== null ? (
                <div className="image-preview" onClick={this.handleAvatarClick}>
                  {this.state.formValues.resourceImage instanceof Blob ? (
                    <img
                      src={URL.createObjectURL(
                        this.state.formValues.resourceImage
                      )}
                      alt="Overlay"
                      className="preview-image"
                    />
                  ) : (
                    <img
                      src={`${API_URL}auth/assets/${
                        this.state.formValues.buildingImage
                      }`}
                      alt="Preview"
                      className="preview-image"
                    />
                  )}
                  {/* <div className="close-icon" onClick={this.handleClearImage}>
                    <FontAwesomeIcon
                      icon={faTrash}
                      style={{ color: "rgb(138, 188, 73)" }}
                    />
                  </div> */}
                </div>
              ) : (
                <div className="image-preview" onClick={this.handleAvatarClick}>
                  {this.state.formValues.resourceImage instanceof Blob && (
                    <>
                      <img
                        src={URL.createObjectURL(
                          this.state.formValues.resourceImage
                        )}
                        alt="Preview"
                        className="preview-image"
                      />

                      {/* <div
                        className="close-icon"
                        onClick={this.handleClearImage}
                      >
                        <FontAwesomeIcon
                          icon={faTrash}
                          style={{ color: "rgb(138, 188, 73)" }}
                        />
                      </div> */}
                    </>
                  )}
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.props.handleClose}>
              Close
            </Button>
            {String(AuthService.getUserTypeAdmin()) !== "3" && (
              <>
                <Button
                  variant="success"
                  type="button"
                  onClick={this.saveForm}
                  id="add-employee"
                >
                  {this.props.option === "edit"
                    ? "Edit Building"
                    : "Add Building"}
                </Button>
              </>
            )}
          </Modal.Footer>
        </Modal>
        {this.state.isModalOpen && (
          <EnlargeImage
            onClose={this.handleAvatarClick}
            imageUrl={
              this.props.option === "edit" &&
              this.state.formValues.resourceImage
                ? URL.createObjectURL(this.state.formValues.resourceImage)
                : this.props.option === "edit" &&
                  this.state.formValues.resourceImage !== null
                ? `${API_URL}auth/assets/${
                    this.state.formValues.buildingImage
                  }`
                : URL.createObjectURL(this.state.formValues.resourceImage)
            }
          />
        )}
      </>
    );
  }

  handleAvatarClick = () => {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    });
  };

  handleChange = (event) => {
    let form = { ...this.state.formValues };

    if (event.target.name === "year") {
      // Remove non-numeric characters
      const numericValue = event.target.value.replace(/\D/g, "");

      // Limit the input to 4 digits
      const truncatedValue = numericValue.slice(0, 4);

      form[event.target.name] = truncatedValue;
    } else {
      form[event.target.name] = event.target.value;
    }

    if (event.target.name === "service_interval") {
      this.setState({
        formValues: form,
        colorChange: true, // Set colorChange to true when equipmentTimeService changes
      });
    } else {
      this.setState({
        formValues: form,
      });
    }
  };

  handlefile = (event) => {
    const file = event.target.files[0];
    console.log("file", file);
    let form = { ...this.state.formValues };
    form[event.target.name] = file;
    this.setState(
      {
        formValues: form,
      },
      () => {
        console.log("thusssss", this.state.formValues);
      }
    );
  };

  saveForm = () => {
  
    if (this.props.option === "edit") {
      if (!this.state.formValues.building_name) {
        this.props.errorToast("Please Enter Building Name");
      } else if (!this.state.formValues.building_desc) {
        this.props.errorToast("Please Enter Building Description");
      } else if (!this.state.formValues.service_interval) {
        this.props.errorToast("Please Choose Time Service Interval");
      } else {
        let form = new FormData(); // Create FormData instance

        // Append each key-value pair from formValues to FormData
        const keysToInclude = [
          "building_id",
          "building_name",
          "building_desc",
          "year",
          "year_acquired",
          "service_interval",
          "buildingImage",
        ];

        // Append only the specified keys from formValues to FormData
        keysToInclude.forEach((key) => {
          form.append(key, this.state.formValues[key]);
        });

        if (this.state.formValues.resourceImage?.name) {
          form.append("resourceImage", this.state.formValues.resourceImage);
        }

        form.append("group_id", parseInt(AuthService.getUserId()));

        BuildingsApi.editBuilding(form).then((response) => {
          if (response.data && response.data.message === "Success") {
            this.props.handleClose();
            this.props.editanddeleteload();
            this.props.renderToast("Edit");
          }
        });
      }
    } else {
      if (!this.state.formValues.building_name) {
        this.props.errorToast("Please Enter Building Name");
      } else if (!this.state.formValues.building_desc) {
        this.props.errorToast("Please Enter Building Description");
      }  else if (!this.state.formValues.service_interval) {
        this.props.errorToast("Please Choose Time Service Interval");
      }else {
        let form = new FormData(); 

       
        for (const key in this.state.formValues) {
          form.append(key, this.state.formValues[key]);
        }

        form.append("group_id", parseInt(AuthService.getUserId()));

       
        console.log("form" , form);

        BuildingsApi.saveBuilding(form).then((response) => {
          if (response.data && response.data.message === "success") {
            this.props.handleClose();
            this.props.onLoad();
            this.props.renderToast("Create");
          }
        });
      }
    }
  };
}
export default CreateBuildings;
